var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 4.5,
    viewBox: "0 0 20.25 4.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.75-9A2.251,2.251,0,0,0-12-11.25,2.251,2.251,0,0,0-14.25-9,2.251,2.251,0,0,0-12-6.75,2.251,2.251,0,0,0-9.75-9Zm5.625-2.25A2.251,2.251,0,0,0-6.375-9a2.251,2.251,0,0,0,2.25,2.25A2.251,2.251,0,0,0-1.875-9,2.251,2.251,0,0,0-4.125-11.25Zm-15.75,0A2.251,2.251,0,0,0-22.125-9a2.251,2.251,0,0,0,2.25,2.25A2.251,2.251,0,0,0-17.625-9,2.251,2.251,0,0,0-19.875-11.25Z",
    transform: "translate(22.125 11.25)",
    fill: "#3a3630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubMenuDots);
export default __webpack_public_path__ + "static/media/subMenu_Dots.93fbbc1b.svg";
export { ForwardRef as ReactComponent };